"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
var Container = (function () {
    function Container() {
        var _this = this;
        this._listeners = [];
        this.setState = function (updater, callback) {
            var nextState;
            if (typeof updater === 'function') {
                nextState = updater(_this.state);
            }
            else {
                nextState = updater;
            }
            if (nextState === null) {
                if (callback)
                    callback(_this.state);
                return Promise.resolve();
            }
            if (nextState && nextState !== _this.state) {
                _this.state = __assign({}, _this.state, nextState);
            }
            var promises = _this._listeners.map(function (listener) { return listener(); });
            return Promise.all(promises).then(function () {
                if (callback && typeof callback === 'function') {
                    callback(_this.state);
                }
            });
        };
        this.subscribe = function (fn) { return _this._listeners.unshift(fn); };
        this.unsubscribe = function (fn) { return _this._listeners = _this._listeners.filter(function (f) { return f !== fn; }); };
    }
    return Container;
}());
exports.Container = Container;
var Context = react_1.default.createContext(null);
var Subscribe = (function (_super) {
    __extends(Subscribe, _super);
    function Subscribe() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._instances = [];
        _this._unmounted = false;
        _this._unsubscribe = function () { return _this._instances.forEach(function (container) { return container.unsubscribe(_this.onUpdate); }); };
        _this._createInstances = function (ctx, containers) {
            if (!ctx)
                throw new Error('You must wrap your <Subscribe> components with a <Provider>');
            _this._unsubscribe();
            _this._instances = containers.map(function (item) {
                var instance;
                if (typeof item === 'object' && item instanceof Container) {
                    instance = item;
                }
                else {
                    instance = ctx.get(item);
                    if (!instance) {
                        instance = new item();
                        ctx.set(item, instance);
                    }
                }
                instance.subscribe(_this.onUpdate);
                return instance;
            });
            return _this._instances;
        };
        _this.onUpdate = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve) { return !_this._unmounted ? _this.setState({}, resolve) : resolve(); })];
            });
        }); };
        return _this;
    }
    Subscribe.prototype.componentWillUnmount = function () {
        this._unmounted = true;
        this._unsubscribe();
    };
    Subscribe.prototype.render = function () {
        var _this = this;
        var _a = this.props, to = _a.to, children = _a.children;
        return (react_1.default.createElement(Context.Consumer, null, function (ctx) { return children.apply(null, _this._createInstances(ctx, to)); }));
    };
    return Subscribe;
}(react_1.default.Component));
exports.Subscribe = Subscribe;
exports.Provider = function (_a) {
    var inject = _a.inject, children = _a.children;
    return (react_1.default.createElement(Context.Consumer, null, function (ctx) {
        var map = new Map(ctx);
        if (inject)
            inject.forEach(function (instance) { return map.set(instance.constructor, instance); });
        return (react_1.default.createElement(Context.Provider, { value: map }, children));
    }));
};
exports.unstated = function (containers, mapStateToProps) {
    return function (Component) {
        var UnstatedComponent = (function (_super) {
            __extends(UnstatedComponent, _super);
            function UnstatedComponent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            UnstatedComponent.prototype.render = function () {
                var _this = this;
                return (react_1.default.createElement(Subscribe, { to: (Array.isArray(containers) ? containers : [containers]) }, function () {
                    var containers = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        containers[_i] = arguments[_i];
                    }
                    var injectProps = {};
                    if (mapStateToProps === undefined) {
                        injectProps = containers.reduce(function (m, c) {
                            var n = c.constructor.name;
                            n = n.charAt(0).toLowerCase() + n.slice(1);
                            m[n] = c;
                            return m;
                        }, {});
                    }
                    else {
                        injectProps = mapStateToProps.apply(void 0, containers);
                    }
                    return react_1.default.createElement(Component, __assign({}, _this.props, injectProps));
                }));
            };
            return UnstatedComponent;
        }(react_1.default.Component));
        UnstatedComponent.displayName =
            "Unstated(" + (Component.displayName || Component.name || 'Component') + ")";
        hoist_non_react_statics_1.default(UnstatedComponent, Component);
        return UnstatedComponent;
    };
};
exports.default = exports.unstated;
